import React from 'react';
export function Footer() {
  return <footer id="site-footer" className="bg-brand-navy px-4 py-10 text-center" data-id="element-88" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-content" data-id="element-89" data-mp="3gg10g6ubc3z8">
        <p className="font-display text-sm font-bold tracking-wide text-white/90" data-id="element-90" data-mp="3gh3n22klrk9c">EDUCAZIONE FISICA PRONTA™</p>
        <div className="mx-auto my-6 h-px max-w-sm bg-white/10" data-id="element-91" data-mp="36p6df098t0cq" />
        <nav aria-label="Note legali" className="flex items-center justify-center gap-3 text-xs text-white/70" data-id="element-92" data-mp="36ppjnjpj60ax">
          <a href="#termini" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-93" data-mp="3ud7g3sjqpmk8">
            Termini
          </a>
          <span aria-hidden="true" data-id="element-94" data-mp="3leviv7odbqit">·</span>
          <a href="#privacy" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-95" data-mp="3ldu8l5f6f825">
            Privacy
          </a>
          <span aria-hidden="true" data-id="element-96" data-mp="29z6t68jqcdeb">·</span>
          <a href="#contatti" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-97" data-mp="29y5frxf8retf">
            Contatti
          </a>
        </nav>
        <p className="mt-6 text-[10px] text-white/45" data-id="element-98" data-mp="2evxat0b6nh1u">© 2026 EDUCAZIONE FISICA PRONTA™. Tutti i diritti riservati.</p>
      </div>
    </footer>;
}